// Generated using typescript-generator version null on 2017-11-03 10:24:59.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class ListIdsDto implements Dto {
  ids: number[];
}

export class PaginateRequestDto {
  pageIndex: number;
  nbElementsParPage: number;
}

export class RechercheFactureDto extends PaginateRequestDto implements Dto {
  numeroFacture: string;
  laboratoires: CorrespondantDto[];
  debutDateEmission: any;
  finDateEmission: any;
  debutDateFacture: any;
  finDateFacture: any;
  montantMin: number;
  montantMax: number;
}

export class Response implements AutoCloseable {
  mediaType: MediaType;
  lastModified: Date;
  date: Date;
  headers: any;
  entity: any;
  metadata: any;
  allowedMethods: string[];
  cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  stringHeaders: any;
  status: number;
  statusInfo: StatusType;
  length: number;
  language: Locale;
  location: URI;
}

export class CorrespondantDetailsDto {
  code: string;
  nom: string;
  adressePrincipale: AdresseDto;
  adresseLivraison: AdresseDto;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export interface Dto {
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class PaginationResult<T> {
  pageIndex: number;
  totalPages: number;
  totalElements: number;
  results: T[];
}

export class FactureDto implements Dto {
  id: number;
  correspondant: string;
  numeroFacture: string;
  dateEmission: any;
  dateFacture: any;
  montant: number;
}

export class MediaType {
  type: string;
  subtype: string;
  parameters: { [index: string]: string };
  wildcardType: boolean;
  wildcardSubtype: boolean;
}

export class Cookie {
  name: string;
  value: string;
  version: number;
  path: string;
  domain: string;
}

export class NewCookie extends Cookie {
  comment: string;
  maxAge: number;
  expiry: Date;
  secure: boolean;
  httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rel: string;
  uriBuilder: UriBuilder;
  rels: string[];
  uri: URI;
  params: { [index: string]: string };
  title: string;
  type: string;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Locale implements Cloneable, Serializable {
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export class AdresseDto {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export class Correspondant {
  code: string;
  nom: string;
  tags: string[];
  dateDesactivation: any;
  metadata: { [index: string]: any };
}

export class UriBuilder {
}

export interface Cloneable {
}

export interface Serializable {
}

export interface Comparable<T> {
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class IPurgeWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * enable
   * Response code 200 - Renvoi si la suppression est activÃ©e
   * HTTP POST /index/enable
   * Java method: fr.cerba.digicerba.factures.webservices.dev.es.IPurgeWebService.enable
   */
  enable(): RestResponse<boolean> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`index/enable`});
  }

  /**
   * purge
   * Response code 200 - Purge des indexes ES terminÃ©e
   * HTTP DELETE /index/purge
   * Java method: fr.cerba.digicerba.factures.webservices.dev.es.IPurgeWebService.purge
   */
  purge(): RestResponse<void> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`index/purge`});
  }

  /**
   * reindex
   * Response code 200 - Reindexation des donnÃ©es terminÃ©e
   * HTTP POST /index/reindex
   * Java method: fr.cerba.digicerba.factures.webservices.dev.es.IPurgeWebService.reindex
   */
  reindex(): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`index/reindex`});
  }
}

@Injectable()
export class IDocumentFactureWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * document/{id}
   * Response code 200 - TÃ©lÃ©chargement terminÃ©
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /factures/document/{id}
   * Java method: fr.cerba.digicerba.factures.webservices.factures.IDocumentFactureWebService.getDocumentDossierContent
   */
  getDocumentDossierContent(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`factures/document/${id}`});
  }

  /**
   * documents
   * Response code 200 - TÃ©lÃ©chargement terminÃ©
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP POST /factures/documents
   * Java method: fr.cerba.digicerba.factures.webservices.factures.IDocumentFactureWebService.getDocumentFacturesContent
   */
  getDocumentFacturesContent(arg0: ListIdsDto): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`factures/documents`, data: arg0});
  }

  /**
   * clean
   * HTTP GET /factures/clean
   * Java method: fr.cerba.digicerba.factures.webservices.factures.IDocumentFactureWebService.nettoyerDocuments
   */
  nettoyerDocuments(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`factures/clean`});
  }
}

@Injectable()
export class IFacturesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * rechercher
   * Response code 200 - Recherche terminÃ©e
   * HTTP POST /factures/rechercher
   * Java method: fr.cerba.digicerba.factures.webservices.factures.IFacturesWebService.rechercherFactures
   */
  rechercherFactures(arg0: RechercheFactureDto): RestResponse<PaginationResult<FactureDto>> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`factures/rechercher`, data: arg0});
  }
}

@Injectable()
export class IIntegrationFacturesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * import
   * Response code 200 - Import terminÃ©
   * HTTP GET /import-factures/csv
   * Java method: fr.cerba.digicerba.factures.webservices.integration.IIntegrationFacturesWebService.integrationCsv
   */
  integrationCsv(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`import-factures/csv`});
  }

  /**
   * import
   * Response code 200 - Import terminÃ©
   * HTTP GET /import-factures/xml
   * Java method: fr.cerba.digicerba.factures.webservices.integration.IIntegrationFacturesWebService.integrationXml
   */
  integrationXml(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`import-factures/xml`});
  }
}

@Injectable()
export class INotificationFacturesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * count
   * Response code 200 - Retourne les notifications de factures
   * Response code 500 - Impossible de retourner les notifications
   * HTTP GET /notification/count
   * Java method: fr.cerba.digicerba.factures.webservices.notifications.INotificationFacturesWebService.countNotificationsFactures
   */
  countNotificationsFactures(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/count`});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

export type RestResponse<R> = Observable<R>;

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/factures/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/resources/resources.ts